export const grids = {
    default: {
        gridTemplateColumns: [null, 'repeat(12, 1fr)'],
        gap: [null, 'm', null, 'xl'],
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ3JpZHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdGhlbWUvZ3JpZHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsTUFBTSxDQUFDLE1BQU0sS0FBSyxHQUF1QztJQUN2RCxPQUFPLEVBQUU7UUFDUCxtQkFBbUIsRUFBRSxDQUFDLElBQUksRUFBRSxpQkFBaUIsQ0FBQztRQUM5QyxHQUFHLEVBQUUsQ0FBQyxJQUFJLEVBQUUsR0FBRyxFQUFFLElBQUksRUFBRSxJQUFJLENBQUM7S0FDN0I7Q0FDRixDQUFDIn0=